import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";
import { elementTreeTraversal } from "../../actionHelpers/elementTreeTraversal";
import { cloneDeep } from "lodash";
import {
  TWebsiteBuilderElementData,
  TWebsiteBuilderElementSettings,
  TWebsiteBuilderElementType,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";

type TPickElementTypeAndSettings<T> = T extends {
  type: TWebsiteBuilderElementType;
  settings: TWebsiteBuilderElementSettings;
}
  ? Pick<T, "type" | "settings">
  : never;

export type TUpdatedElementSettings = TPickElementTypeAndSettings<TWebsiteBuilderElementData>;

export interface IUpdateElementSettingsActionPayload {
  id: string;
  prevElementSettings: TUpdatedElementSettings;
  nextElementSettings: TUpdatedElementSettings;
}

export interface IUpdateElementSettingsAction {
  type: typeof WebsiteBuilderActionType.UPDATE_ELEMENT_SETTINGS;
  payload: IUpdateElementSettingsActionPayload;
}

export function getUpdateElementSettingsInverseAction(
  action: IUpdateElementSettingsAction,
): IUpdateElementSettingsAction {
  const { id, nextElementSettings, prevElementSettings } = action.payload;

  return {
    type: WebsiteBuilderActionType.UPDATE_ELEMENT_SETTINGS,
    payload: {
      id,
      prevElementSettings: cloneDeep(nextElementSettings),
      nextElementSettings: cloneDeep(prevElementSettings),
    },
  };
}

export function applyUpdateElementSettingsTreeChange(
  tree: IWebsiteBuilderRoot,
  action: IUpdateElementSettingsAction,
): IWebsiteBuilderRoot {
  const { id, nextElementSettings } = action.payload;

  const updatedTree = elementTreeTraversal(tree, id, cloneDeep(nextElementSettings));

  return updatedTree;
}
